import { Component, Input } from '@angular/core';
@Component({
  selector: 'app-user-not-found',
  templateUrl: './user-not-found.component.html',
  styleUrls: ['./user-not-found.component.scss']
})
export class UserNotFoundComponent {

  @Input() isLoading: boolean = false;

  constructor() { }

}
